import { Grid, GridItem, Skeleton, Text, VStack } from '@chakra-ui/react'
import { type ReactElement } from 'react'

import { useTranslation } from 'react-i18next'
import CollectionGridSkeleton from './CollectionGridSkeleton'

const CollectionsGridLoader = ({
  scrollEl,
}: {
  scrollEl: HTMLDivElement | null
}): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <VStack padding={'24px'} alignItems="flex-start" spacing={8}>
      <Text fontWeight="semibold" color="appSlate">
        {t('media_collections', 'Media collections')}
      </Text>
      <CollectionGridSkeleton scrollEl={scrollEl} />
    </VStack>
  )
}

export default CollectionsGridLoader
